/**
 * 菜单组件内部状态
 * @internal
 */
class MobileMenuState {
    constructor() {
        /**
         * 存放当前所在的子菜单栈
         */
        this.submenuStack = [];
        /**
         * 存放所有上级菜单的记忆高度
         */
        this.parentMenuHeightStack = [];
        /**
         * 存放所有上级菜单的active tab
         */
        this.parentMenuActiveTabStack = [];
        /**
         * 当前显示的组
         */
        this.groups = [];
        /**
         * 面板高度
         */
        this.panelHeight = 0;
        this.resetFlag = 0;
    }
}

export { MobileMenuState };
//# sourceMappingURL=mobile-menu.interface.js.map
